// Translations
import server from './server'

// Translation: Turkish > Notices
const notices = Object.freeze({
	error: {
		client: {
			appleSignInPopupBlockedError: 'Apple ile giriş yapmak için lütfen açılır pencerelere izin verin.',
			appleSignUpPopupBlockedError: 'Apple ile kayıt olmak için lütfen açılır pencerelere izin verin.',
			applicationTokenFetchingError: 'Giriş yapılamıyor.',
			capthchaExpiredError: 'Captcha’nın süresi doldu.',
			capthchaNotLoadedError: 'Captcha yüklenmedi.',
			emailVerificationCodeResendingError: 'Doğrulama kodu gönderemedik.',
			passwordResetCodeResendingError: 'Bir şifre sıfırlama kodu talep edilemiyor.',
			passwordResetError: 'Şifre sıfırlama başarısız oldu. Lütfen isteğinizi gözden geçirin ve tekrar deneyin.',
			passwordResetRequestError: 'Şifre sıfırlama isteğinizi işlerken bir hatayla karşılaştık.',
			providerAuthenticationError: 'Sağlayıcı ile kimlik doğrulaması yapılamıyor.',
			registrationError: 'Kayıt başarısız oldu. Lütfen isteğinizi gözden geçirin ve tekrar deneyin.',
			unavailableCaptchaTokenError: 'Captcha tokeni mevcut değil.',
			verificationError: 'Doğrulama başarısız oldu. Lütfen isteğinizi gözden geçirin ve tekrar deneyin.'
		},
		fallback: 'Bir hata oluştu. Lütfen isteğinizi doğrulayın ve tekrar deneyin.',
		server: server.errorItems
	},
	success: {
		fallback: 'İşlem başarılı!',
		passwordChangeSuccess: 'Şifre değiştirildi.'
	},
	warning: {
		form: {
			hasAtLeast8CharactersWarning: 'Bu değer en az 8 karakterden oluşmalıdır.',
			hasLowerCaseLetterWarning: 'Bu değer küçük harfli bir karaktere sahip olmalıdır.',
			hasMatchingValueWarning: 'Bu değer bir önceki değerle eşleşmelidir.',
			hasNonEmptyValueWarning: 'Bu değer boş olmamalıdır.',
			hasNumberWarning: 'Bu değer bir sayı içermelidir.',
			hasSpecialCharacterWarning: 'Bu değer özel bir karaktere sahip olmalıdır.',
			hasUnusedValueWarning: 'Bu değer zaten kullanımda.',
			hasUpperCaseLetterWarning: 'Bu değer büyük harfli bir karaktere sahip olmalıdır.',
			isEmailWarning: 'Lütfen geçerli bir e-posta adresi girin.',
			isPersonNameWarning: 'Lütfen geçerli bir isim girin.',
			isPhoneNumberWarning: 'Lütfen geçerli bir telefon numarası girin.',
			isURLWarning: 'Lütfen geçerli bir URL (alan adresi) girin.'
		}
	}
})

// Export
export default notices
